import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Action_User from '../actions/user'
import {Icon, Button, NavBar, InputItem, List} from 'antd-mobile'
import { createForm } from 'rc-form'
const objectAssign = require('object-assign');

class Register extends React.Component {
    constructor(props) {
		super(props);
        const {actions,params} = props;
		actions.setSuccess(false);
    }
    componentDidMount() {
    	const {form,actions} = this.props;
	}
    render() {
        const {data,router,params,orderFields,actions,customerList,loading,licenses,success} = this.props;
        const { getFieldProps, getFieldError, validateFields, setFieldsValue} = this.props.form;
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
        return (
            <div className='csm-body-wapper'>
                <NavBar onLeftClick={()=>{router.push('/apps')}}> 
                   	注册
                </NavBar>
            	<form className="csm-scroll-wapper" >
            		<List>
        				<InputItem clear 
        					{...getFieldProps('companyname',{
        						validateTrigger: ['onBlur','onChange'],
							    rules: [{ validator: this.checkNull.bind(this)}]
							})}
							error={!!getFieldError('companyname')}
							onErrorClick={() => {alert(getFieldError('companyname').join('、'))}}
        				>公司
				        </InputItem>
				        <InputItem clear 
				        	{...getFieldProps('name',{
        						validateTrigger: ['onBlur','onChange'],
							    rules: [{ validator: this.checkNull.bind(this)}]
							})}
				        	error={!!getFieldError('name')}
							onErrorClick={() => {alert(getFieldError('name').join('、'))}}
        				>姓名
				        </InputItem>
				        <InputItem clear 
				        	{...getFieldProps('mail',{
        						validateTrigger: ['onBlur','onChange'],
							    rules: [{ validator: this.checkMail.bind(this)}]
							})} 
							error={!!getFieldError('mail')}
							onErrorClick={() => {alert(getFieldError('mail').join('、'))}}
        				>邮箱
				        </InputItem>
				        <InputItem clear 
				        	{...getFieldProps('mobile',{
        						validateTrigger: ['onBlur','onChange'],
							    rules: [{ validator: this.checkPhoneNum.bind(this) }]
							})} 
							error={!!getFieldError('mobile')}
							onErrorClick={() => {alert(getFieldError('mobile').join('、'))}}
        				>手机号
				        </InputItem>
			    	</List>
	            	<div style={{ margin: 30, textAlign: 'center'}}>
			            <Button type="primary" onClick={this.doSubmit.bind(this)} loading={loading} disabled={success}>{success ? '已提交' : '提交'}</Button>
	        		</div>
            	</form>
	        </div>
        )
    }
    doSubmit(){
        const {validateFields,getFieldsValue} = this.props.form;
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
        const {actions} = this.props;
    	validateFields((errors,values)=>{
    		if(!!errors){
				return
			}else{
				values.type = '0';
				actions.doRegister(values);
			}
    	});
    }
	//申请意向表单验证
	checkNull(rule,value,callback){
		!!value ? callback() : callback([new Error('必填不能为空')]);
	}
	checkMail(rule,value,callback){
		!!value ? (checkMail(value) ? callback() : callback([new Error('请输入正确的邮箱')])) : callback([new Error('必填不能为空')]);
	}
	checkPhoneNum(rule,value,callback){
		!!value ? (checkPhoneNum(value) ? callback() : callback([new Error('请输入正确的电话号码')])) : callback([new Error('必填不能为空')]);
	}

} 

const checkMail = value => {
	return /^([a-z0-9_\-\.]+)@(([a-z0-9]+[_\-]?)\.)+[a-z]{2,3}$/.test(value)
}

const checkPhoneNum = value => {
	return /^(1(([3,8][0-9])|(4[5,7])|(5[^4])|(7[0,6,7,8])))\d{8}$/.test(value)
}


function mapStateToProps(state) {
    const {util,user} = state;
    return {
        loading: util.loading,
        success: user.success
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Action_User, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(createForm()(Register));


// WEBPACK FOOTER //
// ./project/components/Register.js